import React from 'react';
import { AboutTimedStudyTrackerModalProps } from './types';
import { SecondaryButton } from '@magoosh/lib/button';
import { Modal } from 'react-bootstrap';
import style from './style.module.scss';

export const AboutTimedStudyTrackerModal: React.FC<AboutTimedStudyTrackerModalProps> = (props) => {
  const { isOpen, closeModal } = props;

  return (
    <Modal show={isOpen} onHide={() => closeModal()}>
      <Modal.Header className={style.header} closeButton>
        <h3>
          <strong>About the Timed Study Tracker</strong>
        </h3>
      </Modal.Header>
      <Modal.Body className={style.body}>
        <p>
          <strong>
            Unless you have a very long or very short time until your test date, we recommend you spend at
            least 12 hours per week on timed study activities including:
          </strong>
        </p>
        <ul className="u-padding-L-m">
          <li>Watching lesson videos</li>
          <li>Watching answer explanation videos</li>
          <li>Answering practice questions</li>
          <li>Taking timed section practice</li>
          <li>Taking full practice tests</li>
        </ul>

        <p>
          <strong>
            You’ll also need to spend about 20-50% more time on activities we can’t track including:
          </strong>
        </p>

        <ul className="u-padding-L-m">
          <li>Working through the material on scratch paper</li>
          <li>Building your vocabulary</li>
          <li>Reflecting on your missed questions</li>
          <li>Using supplemental practice materials</li>
        </ul>

        <p>
          <strong>
            For example, if you have a goal to complete 12 hours of timed study, you will need to dedicate
            2.5-6 hours for non-timed activities, bringing your total study time to 14.5-18 hours per week.
          </strong>
        </p>

        <SecondaryButton
          onClick={() => {
            closeModal();
          }}
          block={true}
          className="u-margin-T-m">
          Close
        </SecondaryButton>
      </Modal.Body>
    </Modal>
  );
};

export default AboutTimedStudyTrackerModal;
